import React from 'react';
import ExcludedAssignmentClientItem from '../../../../../Domain/ExcludedAssignmentClientItem';
import ExcludedAssignmentItem from '../../../../../Domain/ExcludedAssignmentItem';
import ProjectAssignmentEditItem from '../../../../../Domain/ProjectAssignmentEditItem';
import TabOfDataTable from '../../../../../Elements/DataTable/TabOfDataTable';
import ErrorMessage from '../../../../../Elements/ErrorMessage';
import ButtonColorsEnum from '../../../../../Enums/ButtonColorsEnum';
import ButtonTypeEnum from '../../../../../Enums/ButtonTypeEnum';
import IconPositionEnum from '../../../../../Enums/IconPositionEnum';
import ProjectAssignmentService from '../../../../../Services/ProjectAssignmentsService';
import AssignmentSearchParams from '../AssignmentSearchParams';
import AssignmentsListBase from './AssignmentsListBase';
import FigmaButtonRow from '../../../../../Elements/FigmaButtonRow';

export default class ExcludedAssignmentsList extends AssignmentsListBase {
  constructor(props) {
    super(props);

    this.clickOnMarkAsUninvoiceable = this.clickOnMarkAsUninvoiceable.bind(this);
    this.clickOnGenerateAssignmentPayment = this.clickOnGenerateAssignmentPayment.bind(this);
  }

  getSelected() {
    return this.state.itemList.filter((u) => u.Selected === true);
  }

  getSelectedCount() {
    if (this.getAllItemsInTheSearchAreSelected()) {
      return this.state.numberOfElementsInTheTable;
    }

    return this.state.itemList.filter((u) => u.Selected === true).length;
  }

  renderPanels() {
    return super.renderPanels();
  }

  renderActionButtons() {
    return (
      <FigmaButtonRow
        className={'InnerMenuButtonFigmaList'}
        buttons={[
          {
            disabled: !this.isAnyItemSelected(),
            iconName: 'fa-solid fa-ban',
            type: ButtonTypeEnum.NormalIconOnly,
            color: ButtonColorsEnum.Common,
            iconPosition: IconPositionEnum.Center,
            onClick: () => this.clickOnMarkAsUninvoiceable(),
            tooltip: 'Mark As Uninvoiceable',
            roleKey: 'assignment_edit',
          },
          {
            disabled: !this.isAnyItemSelected(),
            iconName: 'fa-solid fa-file-circle-plus',
            type: ButtonTypeEnum.NormalIconOnly,
            color: ButtonColorsEnum.Common,
            iconPosition: IconPositionEnum.Center,
            onClick: () => this.clickOnGenerateAssignmentPayment(),
            tooltip: 'Generate Assignment Payment',
            roleKey: 'assignment_edit',
          },
        ]}
      />
    );
  }

  clickOnMarkAsUninvoiceable() {
    ErrorMessage.SetApprove(
      `You are about to mark ${this.getSelectedCount()} assignment(s) as uninvoiceable.`,
      this.clickOnModify.bind(this)
    );
  }

  clickOnGenerateAssignmentPayment() {
    ErrorMessage.SetApprove(
      `You are about to generate assignment payment for ${this.getSelectedCount()} assignment(s).`,
      this.clickOnOkGeneratePayment.bind(this)
    );
  }

  clickOnModify() {
    ProjectAssignmentService.EditMultipleAssignment(
      ProjectAssignmentEditItem.createUninvoiceableItem(),
      this.getSelected(),
      this.state.allItemsInTheSearchSetAreSelected,
      this.getSearchParameters()
    )
      .then(() => {
        this.refresh();
      })
      .catch((error) => {
        ErrorMessage.SetErrorMessage('EAL180');
        this.setState({ loading: false });
      });
  }

  clickOnOkGeneratePayment() {
    ErrorMessage.SetNotification(
      'The assignment payment generation process is running in the background. You will receive a message about the result as soon as it has been finished. '
    );
    ProjectAssignmentService.GenerateAssignmentPayment(
      [...this.getSelected().map((s) => s.AsId)],
      this.getSearchParameters(),
      this.state.allItemsInTheSearchSetAreSelected
    )
      .then(() => {
        this.refresh();
      })
      .catch(() => {
        ErrorMessage.SetErrorMessage('Error! ErrorCode: EAL147');
      });
  }

  isAnyItemSelected() {
    return this.state.itemList.find((u) => u.Selected === true) !== undefined;
  }

  getAllItemsInTheSearchAreSelected() {
    return this.state.allItemsInTheSearchSetAreSelected;
  }

  getDisplayType() {
    if (this.props.type === 'excluded_client') {
      return ExcludedAssignmentClientItem;
    }
    return ExcludedAssignmentItem;
  }

  serviceFunction(orderById, orderDir, pageNumber, numberOfElements, searchItem, clearCache) {
    return ProjectAssignmentService.GetAssignmentList(
      orderById,
      orderDir,
      pageNumber,
      numberOfElements,
      this.getSearchParameters(searchItem),
      clearCache
    );
  }

  getTabOfDataTable() {
    return (
      <div>
        {this.renderPanels()}
        <TabOfDataTable
          type={this.getDisplayType()}
          shownPanel={this.state.shownPanel}
          serviceFunction={this.serviceFunction.bind(this)}
          convertDBItemsFunction={ProjectAssignmentService.ConvertExcludedDBItems}
          searchItem={this.state.searchItem}
          searchParamsType={AssignmentSearchParams}
          orderDirection={this.state.orderDirection}
          showSearchStrip={true}
          clickOnStartSearch={this.startSearch}
          itemList={this.state.itemList}
          changeOfItemListFunction={this.changeOfItemListFunction.bind(this)}
          changeOfAllItemsAreSelectedFunction={(allItemsInTheSearchSetAreSelected) => {
            this.setState({ allItemsInTheSearchSetAreSelected });
          }}
          itemTypeName={'assignments'}
          enableUrlPush={false}
          errorCode='EAL149'
          singleSearchLine={true}
          singleSearchLinePlaceholder='Search in Clients, Evaluators, Projects or Apollo Job IDs...'
          forceClearCacheOnSearch={true}
        />
      </div>
    );
  }
}
